import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

import ElementUI from 'element-ui'
import Vue from 'vue'
import VCalendar from 'v-calendar'
import 'element-ui/lib/theme-chalk/index.css'
import 'v-calendar/lib/v-calendar.min.css'

export default () => {
Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ElementUI)
Vue.use(VCalendar)
Vue.use(WechatPlugin)
}




// WEBPACK FOOTER //
// ./src/plugins/setup.js